<template>
   <div style="height: 100vh; width: 100%; margin: 0; padding: 20px 0">
      
         <iframe src="https://docs.google.com/presentation/d/e/2PACX-1vSNyVVGD087bSmtyrlSBSJAqV1KiFYHFQFhYzThZhcPpip3QHxxAqjfQYaT5HxGIw/embed?start=false&loop=false&delayms=3000" 
         frameborder="0" 
         width="1280" 
         height="749" 
         allowfullscreen="true" 
         mozallowfullscreen="true" 
         webkitallowfullscreen="true"></iframe>
      
   </div>
</template>

<script>
export default {
   
}
</script>

<style scoped>

</style>